import React from 'react';
import SolutionInstallmentExaminationReviewContainer from 'containers/SolutionInstallmentExaminationReviewContainer/SolutionInstallmentExaminationReviewContainer';

export default function SolutionInstallmentExaminationReviewPage() {
    return (
        <SolutionInstallmentExaminationReviewContainer />
    )
}
